<section modalContainer invisibleWhitespace>
    <app-modal-header header (close)="close()">공유하기</app-modal-header>
    <div class="relative flex flex-col gap-3 p-4">
        @if (loading()) {
            <div
                class="absolute w-full flex items-center justify-center h-full bg-black/20 inset-0 xl:rounded-b-[20px]"
            >
                <div
                    class="flex items-center justify-center rounded-xl p-4 bg-white w-max z-50"
                >
                    <app-icon
                        name="eos-icons:loading"
                        size="xl"
                        class="text-primary"
                    />
                </div>
            </div>
        }
        <div
            class="flex gap-3 items-center justify-center rounded-xl bg-primary-50 p-3"
        >
            <app-icon
                name="material-symbols:lab-profile"
                class="text-primary"
            />
            <p class="text-gray-800">{{ title() }}</p>
        </div>
        <div class="flex gap-2.5 items-center">
            <button class="share-button flex-1" (click)="handleDownload()">
                <app-icon
                    name="material-symbols:download-2"
                    class="text-gray-400"
                />
                <p class="text-gray-800 text-sm">다운로드</p>
            </button>
            <button class="share-button flex-1" (click)="handleKakaoShare()">
                <app-icon name="ri:kakao-talk-fill" class="text-gray-400" />
                <p class="text-gray-800 text-sm">카카오톡</p>
            </button>
            <button class="share-button flex-1" (click)="handleMailShare()">
                <app-icon
                    name="material-symbols:mail-rounded"
                    class="text-gray-400"
                />
                <p class="text-gray-800 text-sm">메일 발송</p>
            </button>
        </div>
        @if (includeFixDocuments()) {
            <button
                (click)="handleParentShare()"
                class="p-3 flex justify-center items-center gap-2 rounded-xl border border-gray-100 transition-colors hover:bg-gray-50"
            >
                <app-icon
                    name="material-symbols:app-shortcut"
                    class="text-gray-400"
                />
                <p class="text-sm text-gray-800">부모님 앱 공유</p>
                @if (isShared()) {
                    <app-badge color="green" variant="light">공유</app-badge>
                }
            </button>
        }
    </div>
</section>
